import { StringBase } from '../StringBase';

export class PMP extends StringBase {}
